export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20geometric%20technical%20pattern%20with%20warm%20amber%20undertones%2C%20minimalist%20engineering%20linework%20texture%2C%20subtle%20grid%20and%20circuit-like%20details%2C%20dark%20charcoal%20background%20with%20warm%20copper%20accents%2C%20clean%20modern%20aesthetic%2C%20non-representational%2C%20no%20people%2C%20no%20text%2C%20sophisticated%20tech%20atmosphere&width=1600&height=1000&seq=hero-bg-dirbtuviu-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
          DIRBTUVIU CENTRAS, IT
        </h1>
        <p className="mt-8 md:mt-10 text-base md:text-lg lg:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed font-light">
          Professional engineering team designing and developing modern digital software solutions for the iOS platform and related technologies
        </p>
        <div className="mt-14 md:mt-16 w-16 h-px bg-white/30 mx-auto"></div>
      </div>
    </section>
  );
}